import { render } from "./Synthese.vue?vue&type=template&id=ed0453f2&scoped=true"
import script from "./Synthese.vue?vue&type=script&lang=ts"
export * from "./Synthese.vue?vue&type=script&lang=ts"

import "./Synthese.vue?vue&type=style&index=0&id=ed0453f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed0453f2"

export default script